import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { CasesApi } from '../../../infrastructure/api/cases.api';
import { DenyRequestCommand } from './deny-request.command';
import { DenyRequestResult } from './deny-request.result';

@Injectable({ providedIn: 'root' })
export class DenyRequestUseCase {
  private readonly _api = inject(CasesApi);
  private readonly _toast = inject(ToastProvider);

  public execute(command: DenyRequestCommand): Observable<DenyRequestResult> {
    return this._api.denyRequest(command.caseId, command.approvalRequestId, { notes: command.notes }).pipe(
      tap(() => {
        this._toast.success(
          'Denied',
          'The approval request has been denied.'
        );
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._toast.error(
          'Failed to deny',
          'Please try again or contact support if the issue persists.'
        );
        return throwError(() => error);
      })
    );
  }
}
